export default __webpack_public_path__ + "static/media/MARCsymbol.4b521831.png";